import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../repositories/common/json_query';

interface IProjectsProduct {
  id: number;
  offerType: 'CSP';
  position: number;
}

export function trackSuggestShow(sc: IJsonQuery, products: IProjectsProduct[], source?: string): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер "Построить дом"',
        trapid: 'Баннер "Построить дом"',
        source,
      },
    },
    sc,
    products,
  });
}

export function trackProjectClick(id: number, position: number, sc: IJsonQuery, source?: string): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'csp_banner',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'csp',
        bannerName: 'Баннер "Построить дом"',
        trapid: 'Баннер "Построить дом"',
        source,
      },
    },
    sc,
    products: [
      {
        id,
        offerType: 'CSP',
        position,
      },
    ],
  });
}

export function trackAllProjectsClick(sc: IJsonQuery): void {
  ca('eventSite', {
    action: 'show_all_sopr',
    category: 'Listing',
    label: 'suburban_csp',
    name: 'oldevent',
    sc,
    useLastProducts: true,
  });
}
